import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMailbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"mailbox, inbox"} maskId="square-filled-radius-0-stroke-1-IconMailbox"><path d="M16.5 4C19.5376 4 22 6.46243 22 9.5V20H14V22H13V9C13 6.91261 11.9336 5.07483 10.3164 4H16.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M7 4C9.76142 4 12 6.23858 12 9V20H2V9C2 6.23858 4.23858 4 7 4ZM4.5 10H9.5V9H4.5V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMailbox;
